module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loginOrRegister":"Login or Register","greet":"Hello, {name}","contactUs":"Contact us","switchLang":"العربية","logout":"Logout"},"ar":{"loginOrRegister":"تسجيل الدخول","greet":"مرحبا، {name}","contactUs":"اتصل بنا","switchLang":"English","logout":"تسجيل الخروج"}}')
  delete Component.options._Ctor
}
